import React, { useState, useEfect } from "react";
import Markdown from "markdown-to-jsx";
import jet from "@randajan/jet-core";
import { usePromise } from "@randajan/jet-react";
import { apiGet } from "../tools";
import Photo from "../../App/Photo/Photo";

const _ee = {
  avatar:Photo
}

const extraElements = props=>{
  const src = String.jet.to(props.src).split("/");
  const kind = src.shift().toLowerCase();
  const Extra = _ee[kind];
  return Extra ? <Extra {...props} src={src.join("/")}/> : <img {...props}/>;
}

export const Article = _ee.article = props => {
  const { src, className, overrides } = props;

  const [article, refresh] = usePromise([], _ => apiGet("web_articles", src), [src]);

  const propsPass = {
    ...props,
    overrides: null,
    src:null,
    id: String.jet.to(src).replace(/[^a-zA-Z0-9]+/g, " ").trim().replaceAll(" ", "-"),
    className,
    children: String.jet.to(article?.content),
    options: {
      wrapper:"article",
      forceWrapper:true,
      overrides: {
        ...overrides,
        img:extraElements
      }
    }
  }

  return <Markdown {...propsPass} />;
}